var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import config from "@/config";
import { Controller } from "stimulus";
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.initialize = function () {
        console.log("[connect] Racer");
    };
    default_1.prototype.connect = function () {
        console.log("[connect] Racer");
        this.element.style.animationDelay = "-" + Math.random() * 10 + "s";
        if (window.innerWidth < config.breakPointMD) {
            // sm
            if (this.element.classList.contains("racer__item--lg")) {
                this.element.style.animationDuration = window.innerWidth * 10 + "ms";
            }
            else if (this.element.classList.contains("racer__item--md")) {
                this.element.style.animationDuration = window.innerWidth * 15 + "ms";
            }
            else if (this.element.classList.contains("racer__item--sm")) {
                this.element.style.animationDuration = window.innerWidth * 20 + "ms";
            }
            this.element.style.animationName = "forwardSm";
        }
        else if (window.innerWidth < config.breakPointLG) {
            // md
            if (this.element.classList.contains("racer__item--lg")) {
                this.element.style.animationDuration = window.innerWidth * 6 + "ms";
            }
            else if (this.element.classList.contains("racer__item--md")) {
                this.element.style.animationDuration = window.innerWidth * 12 + "ms";
            }
            else if (this.element.classList.contains("racer__item--sm")) {
                this.element.style.animationDuration = window.innerWidth * 18 + "ms";
            }
            this.element.style.animationName = "forwardSm";
        }
        else {
            // lg
            if (this.element.classList.contains("racer__item--lg")) {
                this.element.style.animationDuration = window.innerWidth * 4 + "ms";
            }
            else if (this.element.classList.contains("racer__item--md")) {
                this.element.style.animationDuration = window.innerWidth * 8 + "ms";
            }
            else if (this.element.classList.contains("racer__item--sm")) {
                this.element.style.animationDuration = window.innerWidth * 12 + "ms";
            }
            this.element.style.animationName = "forward";
        }
    };
    default_1.prototype.disconnect = function () {
        console.log("[disconnect] Racer");
    };
    return default_1;
}(Controller));
export default default_1;
